<template>
  <v-app>
    <v-app-bar app color="primary" dark dense>
      <div class="d-flex align-center">Vue Webcam Demo</div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/VinceG/vue-web-cam"
        target="_blank"
        text
        small
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main style="background: #e5e5e5">
      <web-cam />
    </v-main>
  </v-app>
</template>

<script>
import WebCam from "./components/WebCam";

export default {
  name: "App",

  components: {
    WebCam,
  },

  data: () => ({
    //
  }),
};
</script>
